import { FC, PropsWithChildren } from 'react'
import { Token } from '@revolut-internal/ui-kit'

import {
  MessageBubbleContentWrapper,
  MessageBubbleInteractiveContainer,
} from './MessageBubble.styles'
import { SubjectTail } from '../SubjectTail'
import { MessageColorSchema } from '../../ChatMessage.types'
import { messageBubbleMinHeight } from './MessageBubble.constants'

interface MessageBubbleProps extends PropsWithChildren {
  colorSchema: MessageColorSchema
  position: 'left' | 'right'
  title?: string
  isInteractable?: boolean
  isSelected?: boolean
}

export const MessageBubble: FC<MessageBubbleProps> = ({
  children,
  colorSchema,
  position,
  title,
  isInteractable = false,
  isSelected = false,
}) => {
  return (
    <MessageBubbleInteractiveContainer
      overflow="hidden"
      px="s-6"
      isInteractable={isInteractable}
      isSelected={isSelected}
    >
      {!isSelected && <SubjectTail color={colorSchema.bgColor} position={position} />}
      <MessageBubbleContentWrapper
        title={title}
        minHeight={messageBubbleMinHeight}
        radius={Token.radius.widget}
        colorSchema={colorSchema}
        backgroundColor={Token.color.background}
      >
        {children}
      </MessageBubbleContentWrapper>
    </MessageBubbleInteractiveContainer>
  )
}
